// frontend/src/components/common/DialogErrorBanner.jsx
//
// Shared error banner for MUI Dialogs.
//
// Rendered inside <DialogContent> as its LAST child. Uses position:sticky
// with bottom:0 so the banner stays pinned just above <DialogActions> when
// the user scrolls — the save button and the error message are always
// visible together.

import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, Box } from '@mui/material';
import AlertActionSlot from './AlertActionSlot';

function DialogErrorBanner({
  error,
  onClose,
  severity = 'error',
  heading,
  children,
}) {
  const { t } = useTranslation();
  if (!error && !children) return null;

  const resolvedHeading = heading ?? t('common.errorHeading');

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 2,
        mt: 'auto',
        pt: 1,
        backgroundColor: 'var(--color-surface)',
      }}
    >
      <Alert severity={severity} variant="standard" action={onClose && <AlertActionSlot onDismiss={onClose} />}>
        {resolvedHeading && <AlertTitle>{resolvedHeading}</AlertTitle>}
        {error}
        {children}
      </Alert>
    </Box>
  );
}

export default DialogErrorBanner;
